import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import { AuthPopupHOC } from "@/_MiniApps/auth/AuthContext";
import { useMemo } from "react";
import banners from "@data/banners/login-pages/saved_search.json";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useCMS } from "@hooks/useCMS";
import { trackEvents } from "@/common/events/events";
import { toast } from "sonner";
import { TAG_TYPES } from "@/pages/saved-search/saved-search";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
var SaveSearchBanner = function SaveSearchBanner() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var _useSearchResultsData = useSearchResultsData(),
    selectedOptions = _useSearchResultsData.selectedOptions;
  var _useFilterPage = useFilterPage(),
    handleSaveFilters = _useFilterPage.handleSaveFilters;
  var authScreenDesign = useMemo(function () {
    return {
      banners: {
        desktop: imageUrl(banners[lang].desktop_images[0]),
        mobile: imageUrl(banners[lang].mobile_images[0])
      },
      title: t("تسجيل دخول/إنشاء حساب", {
        ns: "web_common"
      }),
      description: t("سجل رقم جوالك بكل سهولة و احفظ بحثك", {
        ns: "web_common"
      })
    };
  }, []);
  var handleClickSave = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _res$data, res, _res$data2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            trackEvents("element_click", {
              element_name: "save_search",
              user_login_status: "true"
            });
            _context.prev = 1;
            _context.next = 4;
            return handleSaveFilters();
          case 4:
            res = _context.sent;
            if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.success) === true)) {
              _context.next = 10;
              break;
            }
            toast.success(t('تم حفظ البحث يمكنك العودة إليه من قائمة حسابي', {
              ns: "saved_search"
            }), {
              position: "top-center",
              duration: 5000,
              style: {
                zIndex: 9999999
              }
            });
            trackEvents("save_search_click", {
              filter_count: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length,
              filter_name: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (option) {
                var property = {};
                if (option.type === TAG_TYPES.RANGE) {
                  property[option.filterField] = "".concat(option.range_values.from, "-").concat(option.range_values.to);
                } else {
                  property[option.filterField] = option.name_en;
                }
                return property;
              })
            });
            _context.next = 11;
            break;
          case 10:
            throw new Error((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.errors) || "something went wrong");
          case 11:
            _context.next = 17;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.log(_context.t0.message);
            toast.error(_context.t0.message, {
              position: "bottom-center",
              style: {
                zIndex: 9999999
              }
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 13]]);
    }));
    return function handleClickSave() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthPopupHOC, {
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "save_search",
        user_login_status: "false"
      });
    },
    renderFunc: function renderFunc(checkAuth) {
      return /*#__PURE__*/React.createElement("div", {
        className: "bg-blue-water py-2 px-3 rounded flex items-center justify-between",
        onClick: function onClick() {
          return checkAuth(handleClickSave);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-1"
      }, /*#__PURE__*/React.createElement("img", {
        className: "w-6 h-6",
        src: CDN_LINK + "/assets/images/save.svg",
        alt: "save"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-gray-text text-sm font-semibold"
      }, t("احفظ بحثك", {
        ns: "saved_search"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "text-blue-old"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-xs font-bold underline cursor-pointer"
      }, t("حفظ البحث", {
        ns: "saved_search"
      }))));
    }
  }));
};
export default SaveSearchBanner;